import * as config from "../data/config";
import LocalStorageHelper from "../common/localStorageHelper";

class AllStationApi {
    static fetchAllStationNames() {
        let api = config.environment.api;
        let url = api.baseURL + api.getStationNamesURL;
        //console.info("getstation url", url);
        let user = LocalStorageHelper.getUser();
        let token = "";
        if (user && user.token) {
            token = user.token;
            // console.info("getstation token", token);
        }
        return fetch(url, {
            headers: {
                Authorization: token,
            },
        })
            .then(function (response) {
                return response.json();
            })
            .then((payload) => {
                // console.info("payload 11", payload);
                return payload;
            });
    }
}

export default AllStationApi;
